<template>
    <el-tooltip
        :popper-class="[props.rows == 1 ? 'overflowTooltip' : 'overflowTooltipLight', props.fill ? 'fill' : '']"
        :effect="props.effect"
        :content="displayTooltipContent"
        :placement="props.placement"
        :disabled="isShow"
    >
        <template #content>
            <slot name="tooltipContent">
                <p v-if="displayTitle" class="title">{{ displayTitle }}</p>
                {{ displayTooltipContent }}
            </slot>
        </template>
        <div
            :class="props.rows == 1 ? 'content-1' : 'content'"
            :style="{ width: props.width }"
            @mouseover="isShowTooltip"
        >
            <span ref="contentRef">
                <slot name="content">
                    {{ displayContent }}
                </slot>
            </span>
        </div>
    </el-tooltip>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
    content: {
        type: [String, Number],
        default: '',
    },
    width: {
        type: String,
        default: '100%',
    },
    tooltipContent: {
        type: [String, Number],
        default: '',
    },
    placement: {
        type: String,
        default: 'top',
    },
    rows: {
        type: Number,
        default: 1,
    },
    lineHeight: {
        type: Number,
        default: 20,
    },
    effect: {
        type: String,
        default: 'dark',
    },
    title: {
        type: [String, Number],
        default: '',
    },
    fill: {
        type: Boolean,
        default: false,
    },
});

const rows = computed(() => props.rows);
const isShow = ref(false);
const contentRef = ref(null);

function toText(value) {
    return value === null || value === undefined ? '' : String(value);
}

function hasTooltipContent(value) {
    return value !== '' && value !== null && value !== undefined;
}

const displayContent = computed(() => toText(props.content));
const displayTooltipContent = computed(() =>
    hasTooltipContent(props.tooltipContent) ? toText(props.tooltipContent) : displayContent.value
);
const displayTitle = computed(() => toText(props.title));

const isShowTooltip = function () {
    if (props.rows == 1) {
        if (contentRef.value.parentNode.offsetWidth >= contentRef.value.offsetWidth) {
            isShow.value = true;
        } else {
            isShow.value = false;
        }
    } else if (contentRef.value.offsetHeight >= props.rows * props.lineHeight) {
        isShow.value = false;
    } else {
        isShow.value = true;
    }
};
</script>

<style lang="scss" scoped>
.content-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.content {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: v-bind('rows');
    overflow: hidden;
}

.title {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #000000;
    margin-bottom: 6px;
    font-weight: normal;
}
</style>

<style lang="scss">
.overflowTooltip {
    max-width: 400px;
    background: #444;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
}

.overflowTooltip ::before {
    background: #444;
}

.overflowTooltipLight {
    max-width: 380px;
    background: #fff;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #666666;
    line-height: 22px;
    padding: 20px;
    padding-top: 16px;

    &.fill {
        max-width: 100%;
    }
}

.overflowTooltipLight.is-light {
    background: #fff;
    border: none;
    box-shadow: 0px 4px 16px 0px rgba(11, 23, 73, 0.1);

    .el-popper__arrow::before {
        box-shadow: 0px 4px 16px 0px rgb(11 23 73 / 10%);
        border: none;
    }
}
</style>
